import type { RequestInterface } from '~/common/types';
import type { Document, DocumentID } from '~/documents/types';

export class CreateDocumentRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/documents/upload';
  headers: Record<string, any>;
  data: FormData;

  constructor({ token, document }: { token: string; document: FormData }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = document;
  }
}

export class DocumentsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/documents';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class GetDocumentRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    id,
    params,
  }: {
    token: string;
    id: DocumentID;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/documents/${id}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class DownloadDocumentRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({ token, id }: { token: string; id: DocumentID }) {
    this.path = `/api/v1/documents/download/${id}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}

export class UpdateDocumentRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    documentID,
    document,
    params,
  }: {
    token: string;
    documentID: DocumentID;
    document: Document;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/documents/${documentID}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...document,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class DeleteDocumentRequest implements RequestInterface {
  method = 'delete';
  path: string;
  headers: Record<string, any>;

  constructor({ token, id }: { token: string; id: DocumentID }) {
    this.path = `/api/v1/documents/${id}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}
